import type { TenantConfig } from '@/types/TenantConfig'

const blue = '#295cf0'
const black = '#101820'

export const theinfinite: TenantConfig = {
  logo: 'assets/theinfinite/static/logo.svg',
  themeOptions: {
    primaryColor: blue,
    secondaryColor: blue,
    headerBackground: black,
    footerBackgroundColor: black,
    footerTextColor: 'white',
    logoHeight: '75px',
    headerHeight: '128px',
    cartHeaderBackgroundColor: black,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/theinfinite/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
